export const setMarketId=id=>{
    return {type:'SET_MARKET_ID' , payload:id}
}